export default function rpm (velocity, twistRate) {
  return (720 * velocity) / twistRate
}
